var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtozIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.2858L16.2857 20.5715L20.5714 16.2858",
    stroke: "#171A1F",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2857 20.5714L16.2857 3.42859",
    stroke: "#171A1F",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03945 11.1428L8.41888 9.1037L5.29545 9.1037L4.67488 11.1428H2.71716L5.74288 2.57141L7.96202 2.57141L10.9972 11.1428H9.03945ZM7.98516 7.58055C7.41373 5.73255 7.09059 4.6877 7.01573 4.44598C6.94288 4.19998 6.89145 4.01227 6.85716 3.8717C6.72859 4.3717 6.35945 5.60798 5.74973 7.58055H7.98516Z",
    fill: "#171A1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0449 21.4286H3.66943L3.66943 20.2509L7.77686 14.3623L3.78086 14.3623L3.78086 12.8623L9.93343 12.8623V14.034L5.82858 19.9286H10.0449V21.4286Z",
    fill: "#171A1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtozIcon);
export default __webpack_public_path__ + "static/media/atozIcon.34d7e83b18636cb9218b2f686e368a6a.svg";
export { ForwardRef as ReactComponent };